// extracted by mini-css-extract-plugin
export default {"container__copy_text":"styles_container__copy_text__XsJBt","text":"styles_text__EOtCY","disabled":"styles_disabled__9mwUp","button":"styles_button__CY-Rx"};